module.exports = "/assets/newsletter-respect.jpg?+vgMEXb";